module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_26.c68e3ff0.png";